module.exports = __webpack_public_path__ + "static/media/dia3.708ea0e8.webp";